'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosMusicalNotes = function IoIosMusicalNotes(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 25c0 2.7 0.3 6.3-3.8 6.4-3.9 0.2-4.9-1.2-4.9-3.2 0-1.6 0.7-3 4.1-3.2 1.8-0.1 2.6-0.2 3.4-0.2v-12.5l-15 2.5v12.6c0 2.7 0.3 6.4-3.9 6.5-3.8 0.2-4.9-1.3-4.9-3.3 0-1.5 0.7-3 4.1-3.2 1.8-0.1 2.7-0.1 3.4-0.1v-18.5l17.5-2.7v18.9z' })
        )
    );
};

exports.default = IoIosMusicalNotes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-musical-notes.js
// module id = 2220
// module chunks = 0